import {createReducer, on} from "@ngrx/store"
import {
  ClearSelectedResource,
  ClearState,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchOrganisationsListFailure,
  FetchOrganisationsListRequest,
  FetchOrganisationsListSuccess,
  DeleteResourceFailure,
  DeleteResourceRequest,
  DeleteResourceSuccess,
  FetchCategoriesListFailure,
  FetchCategoriesListRequest,
  FetchCategoriesListResourceListFailure,
  FetchCategoriesListResourceListRequest,
  FetchCategoriesListResourceListSuccess,
  FetchCategoriesListSuccess,
  FetchRelatedResourcesFailure,
  FetchRelatedResourcesRequest,
  FetchRelatedResourcesSuccess,
  FetchResourceDetailsForEditFailure,
  FetchResourceDetailsForEditRequest,
  FetchResourceDetailsForEditSuccess,
  FetchResourceListFailure,
  FetchResourceListRequest,
  FetchResourceListSuccess,
  FetchResourceStatusFailure,
  FetchResourceStatusRequest,
  FetchResourceStatusSuccess,
  FetchRolesListFailure,
  FetchRolesListRequest,
  FetchRolesListResourceListFailure,
  FetchRolesListResourceListRequest,
  FetchRolesListResourceListSuccess,
  FetchRolesListSuccess,
  FetchSessionListFailure,
  FetchSessionListRequest,
  FetchSessionListResourceListFailure,
  FetchSessionListResourceListRequest,
  FetchSessionListResourceListSuccess,
  FetchSessionListSuccess,
  FetchSubCategoriesListFailure,
  FetchSubCategoriesListRequest,
  FetchSubCategoriesListResourceListFailure,
  FetchSubCategoriesListResourceListRequest,
  FetchSubCategoriesListResourceListSuccess,
  FetchSubCategoriesListSuccess,
  GetResourceDetailFailure,
  GetResourceDetailRequest,
  GetResourceDetailSuccess,
  SaveOrPublishResourceFailure,
  SaveOrPublishResourceRequest,
  SaveOrPublishResourceSuccess,
  UpdateHeroSectionDetailsAddResources,
  UpdateSectionDetailsAddResources
} from "./resources-hub.actions"
import {
  CategoriesResponse,
  Resource,
  ResourceDetails,
  ResourceResponseData,
  Role,
  Session
} from "../model/resource-model"
import {DropdownOption} from "../../../../models/dropdown-option.model";

export interface ResourcesHubState {
  dummy: boolean,
  resourceDetails: ResourceDetails,
  addResources: ResourceDetails,
  sessionData: {
    loading: boolean,
    list: Session[]
  },
  rolesList: {
    hasNext?: boolean,
    hasPrev?: boolean,
    limit?: number,
    list?: Role[],
    pageNumber?: number,
    total?: number
    loading?: boolean
  },
  categoriesList: CategoriesResponse[],
  organisationsData: {
    loading: boolean,
    list: any[]
  },
  groupsData: {
    loading: boolean,
    list: any[]
  },
  relatedResourcesData?: {
    loading?: boolean,
    list?: ResourceResponseData
  },
  resourceList?: {
    session: {
      loading: boolean,
      list: Session[]
    },
    rolesList: {
      hasNext?: boolean,
      hasPrev?: boolean,
      limit?: number,
      list?: Role[],
      pageNumber?: number,
      total?: number
      loading?: boolean
    },
    categoriesList?: {
      loading?: boolean,
      list: DropdownOption[]
    },
    subCategoriesList?: {
      loading?: boolean,
      list?: DropdownOption[]
    }
    resources: {
      hasNext?: boolean
      hasPrev?: boolean
      limit?: number,
      pageNumber?: number,
      total?: number,
      list?: Resource[]
      loading?: boolean,
    },
    statusList?: {
      list?: DropdownOption[],
      loading?: boolean
    }
  }
}

const initialState: ResourcesHubState = {
  dummy: true,
  resourceDetails: {},
  addResources: {},
  sessionData: {
    loading: false,
    list: []
  },
  rolesList: {},
  categoriesList: [],
  organisationsData: {
    loading: false,
    list: []
  },
  groupsData: {
    loading: false,
    list: []
  },
  relatedResourcesData: {
    loading: false,
    list: {}
  },
  resourceList: {
    session: {
      loading: false,
      list: []
    },
    rolesList: {
      loading: false,
      list: [], hasNext: false,
      hasPrev: false,
      limit: null,
      pageNumber: 0,
      total: 0
    },
    categoriesList: {
      list: [],
      loading: false
    },
    subCategoriesList: {
      list: [],
      loading: false
    },
    resources: {
      loading: false,
      list: [],
      hasNext: false,
      hasPrev: false,
      limit: 0, total: 0,
      pageNumber: 0
    },
    statusList: {
      list: [],
      loading: false
    }
  }

}

export const reducer = createReducer(
  initialState,

  on(GetResourceDetailSuccess, (state, props) => {
    return ({...state, resourceDetails: props.data})
  }),

  on(GetResourceDetailRequest, (state, props) => {
    return ({...state, resourceDetails: {}})
  }),

  on(GetResourceDetailFailure, (state, props) => {
    return ({...state, resourceDetails: {}})
  }),

  on(UpdateHeroSectionDetailsAddResources, (state, props) => ({
    ...state,
    addResources: {...state.addResources, ...props.data, status: null}
  })),
  on(UpdateSectionDetailsAddResources, (state, props) => {
    return ({...state, addResources: {...state.addResources, sections: [...props.section], status: null}})
  }),

  on(FetchSessionListRequest, (state, props) => {
    return ({...state, sessionData: {list: [], loading: true}})
  }),

  on(FetchSessionListSuccess, (state, props) => {
    return ({...state, sessionData: {list: [...props.sessionList], loading: false}})
  }),

  on(FetchSessionListFailure, (state, props) => {
    return ({...state, sessionData: {list: [], loading: false}})
  }),

  on(FetchRolesListRequest, (state, props) => {
    return ({...state, rolesList: {loading: true}})
  }),

  on(FetchRolesListSuccess, (state, props) => {
    return ({...state, rolesList: {...props.roleList, loading: false}})
  }),

  on(FetchRolesListFailure, (state, props) => {
    return ({...state, rolesList: {loading: false}})
  }),

  on(FetchCategoriesListRequest, (state) => state),

  on(FetchCategoriesListSuccess, (state, props) => {
    return ({...state, categoriesList: [...props.categories]})
  }),

  on(FetchCategoriesListFailure, (state) => state),

  on(FetchSubCategoriesListRequest, (state, props) => ({...state, categoriesList: props.payload.categoriesData ? props.payload.categoriesData : state.categoriesList})),

  on(FetchSubCategoriesListSuccess, (state, props) => {
    return ({...state, categoriesList: [...props.subCategoriesList]})
  }),

  on(FetchSubCategoriesListFailure, (state) => state),

  on(FetchRelatedResourcesRequest, (state,props) => ({...state, relatedResourcesData: {
    loading: true,
     list: {
      ...state.relatedResourcesData.list,
      list:[
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.relatedResourcesData.list.list] :
            []
        )
      ],
     }
    }})),

  on(FetchRelatedResourcesSuccess, (state, props) => {
    return ({
      ...state, relatedResourcesData: {
        loading: false,
        list: {
          ...
            props.resources, 
            list:[
              ...(props.resources.pageNumber === 1 ? 
                props.resources.list : 
                [...state.relatedResourcesData.list.list,...props.resources.list])
              ]
          
        }
      }
    })
  }),

  on(FetchRelatedResourcesFailure, state => ({...state, relatedResourcesData: {loading: false, list: state.relatedResourcesData.list}})),

  on(SaveOrPublishResourceRequest, (state) => state),

  on(SaveOrPublishResourceSuccess, (state, props) => {
    return ({...state, addResources: {...props.payload.resource}})
  }),

  on(SaveOrPublishResourceFailure, state => state),

  on(FetchResourceDetailsForEditRequest, (state, props) => ({...state, addResources: {}})),

  on(FetchResourceDetailsForEditSuccess, (state, props) => ({...state, addResources: {...props.resourceDetails}})),

  on(FetchResourceDetailsForEditFailure, (state, props) => state),

  on(DeleteResourceRequest, (state) => state),

  on(DeleteResourceSuccess, (state) => ({...state, addResources: {}})),

  on(DeleteResourceFailure, (state) => state),

  on(FetchSessionListResourceListRequest, (state) => ({...state, resourceList: {...state.resourceList, session: {loading: true, list: []}}})),

  on(FetchSessionListResourceListSuccess, (state, props) => {
    return ({
      ...
        state, resourceList:
        {
          ...
            state.resourceList, session:
            {
              loading: false, list:
                [...props.payload.sessionList]
            }
        }
    })
  }),

  on(FetchSessionListResourceListFailure, (state) => ({...state, resourceList: {...state.resourceList, session: {loading: false, list: []}}})),

  on(FetchRolesListResourceListRequest, (state) => ({
    ...state, resourceList: {
      ...state.resourceList, rolesList: {
        ...state.rolesList, loading: true
      }
    }
  })),

  on(FetchRolesListResourceListSuccess, (state, props) => ({...state, resourceList: {...state.resourceList, rolesList: {...props.payload.roleList, loading: false}}})),

  on(FetchRolesListResourceListFailure, (state) => ({...state, resourceList: {...state.resourceList, rolesList: {...state.rolesList, loading: false}}})),

  on(FetchCategoriesListResourceListRequest, (state) => ({...state, resourceList: {...state.resourceList, categoriesList: {loading: true, list: []}}})),

  on(FetchCategoriesListResourceListSuccess, (state, props) => ({...state, resourceList: {...state.resourceList, categoriesList: {loading: false, list: props.payload.categories}}})),

  on(FetchCategoriesListResourceListFailure, (state) => ({...state, resourceList: {...state.resourceList, categoriesList: {...state.resourceList.categoriesList, loading: false}}})),

  on(FetchSubCategoriesListResourceListRequest, (state) => ({...state, resourceList: {...state.resourceList, subCategoriesList: {loading: true, list: []}}})),

  on(FetchSubCategoriesListResourceListSuccess, (state, props) => ({...state, resourceList: {...state.resourceList, subCategoriesList: {loading: false, list: [...props.payload.subCategories]}}})),

  on(FetchSubCategoriesListResourceListFailure, (state) => ({...state, resourceList: {...state.resourceList, subCategoriesList: {...state.resourceList.categoriesList, loading: false}}})),

  on(FetchResourceListRequest, (state, props) => ({
    ...state,
    resourceList: {
      ...state.resourceList,
      resources: {
        list: [
          ...(
            props.payload?.pageNumber ?
            props.payload?.pageNumber === 1 ? [] : [...state.resourceList.resources.list] :
              []
          )
        ],
        loading: true
      }
    }
  })),

  on(FetchResourceListSuccess, (state, props) => ({
    ...state,
    resourceList: {
      ...state.resourceList,
      resources: {
        ...props.data,
        list: [
          ...(props.data.pageNumber === 1 ? [
            ...props.data.list
          ] : [
            ...state.resourceList.resources.list,
            ...props.data.list
          ])
        ],
        loading: false
      }
    }
  })),

  on(FetchResourceListFailure, (state, props) => ({
    ...state,
    resourceList: {
      ...state.resourceList,
      resources: {
        loading: false,
        list: [],
        hasNext: false,
        hasPrev: false,
        limit: 0, total: 0,
        pageNumber: 0
      }
    }
  })),

  on(FetchResourceStatusRequest, (state) => ({
    ...state, resourceList: {
      ...state.resourceList, statusList: {
        ...state.resourceList.statusList,
        loading: true,
      }
    }
  })),

  on(FetchResourceStatusSuccess, (state, props) => ({
    ...state, resourceList: {
      ...state.resourceList, statusList: {
        loading: false, list: props.payload.statusList
      }
    }
  })),

  on(FetchResourceStatusFailure, (state) => ({
    ...state, resourceList: {
      ...state.resourceList, statusList: {
        ...state.resourceList.statusList,
        loading: false,
      }
    }
  })),

  // ORGANISATIONS
  on(FetchOrganisationsListRequest, (state) => ({...state, organisationsData: {list: [], loading: true}})),
  on(FetchOrganisationsListSuccess, (state, props) => ({...state, organisationsData: {list: props.organisationsList, loading: false}})),
  on(FetchOrganisationsListFailure, (state) => ({...state, organisationsData: {list: [], loading: false}})),

  // GROUPS
  on(FetchGroupsListRequest, (state) => ({...state, groupsData: {list: [], loading: true}})),
  on(FetchGroupsListSuccess, (state, props) => ({...state, groupsData: {list: props.groupsList, loading: false}})),
  on(FetchGroupsListFailure, (state) => ({...state, groupsData: {list: [], loading: false}})),

  on(ClearSelectedResource, (state, props) => ({...state, addResources: {}})),

  //clear state
  on(ClearState, (state) => initialState)
)
